import myHeader from "../../components/header.vue"
import myFooter from "../../components/footer.vue"
import {
  detailsNews
} from "@/apiCloud/news";
import {
  pUrl
} from "@/api/baseURL.js";
export default {
  components: {
    myHeader,
    myFooter
  },
  data() {
    return {
      newsCategory: 1,
      newsContent: '',
      newsIstop: '',
      newsPic: '',
      newsReleaseTime: '',
      newsTitle: '',
      sysCreatetime: '',
      isJx: false,
      toWxCode:"",
    }
  },
  created() {
    this.getdetailsNews()
    if (localStorage.getItem("isJx") == "true") { // 是否是江西代理商访问
      this.isJx = true;
    }
    // var pUrl=window.location.href;
    // // 是否是江西代理商访问
    //     if(pUrl=="http://jx.eceping.net"||pUrl.substring(0,pUrl.indexOf("/",7))=="http://jx.eceping.net"||pUrl.substring(0,pUrl.indexOf("/",7))=="http:/jx.eceping.net:8080"){//jx.eceping.net域名时,显示关于我们
    //     console.log(1111,this.isJx)
    //     this.isJx=true;
    // }
  },
  mounted() {
    var publicCourse = document.getElementById("newsDetailBox")
    publicCourse.style.minHeight = document.body.scrollHeight - 90 - 257 + "px"
  },
  methods: {
    //获取新闻详情
    getdetailsNews() {
      let data = {
        newsId: this.$route.query.newsId
      }
      detailsNews(data).then(res => {
        // console.log("新闻详情", res)
        if (res.code == 200) {
          this.toWxCode = res.data.toWxCode
          this.newsCategory = res.data.newsCategory
          this.newsContent = res.data.newsContent
          this.newsIstop = res.data.newsIstop
          this.newsPic = res.data.newsPic
          this.newsReleaseTime = res.data.newsReleaseTimeStr
          this.newsTitle = res.data.newsTitle
          this.sysCreatetime = res.data.sysCreatetime
        }
      })
    },
    //返回上一页
    goBack() {
      this.$router.go(-1)
    }
  },
}



// WEBPACK FOOTER //
// ./src/pages/newsDetail/newsDetail.js